import { useMutation, useQueryClient } from '@tanstack/react-query';
import { DownloadInfographic } from '../api/api';


export const useDownloadInfographic = ({ onSuccessCallback, onErrorCallback }) => {

  return useMutation({
    mutationFn: async ({ data }) => {
      const res = await DownloadInfographic(data);
      if (res.error) throw new Error(res.error);
      return res.data;
    },
    onSuccess: (newData) => {
      if (onSuccessCallback) {
        onSuccessCallback();
      }
    },
    onError: (err) => {
      if (onErrorCallback) {
        onErrorCallback(err.message || 'Failed to submit');
      }
    },
  });
};

